module.exports = __webpack_public_path__ + "static/media/23.0638df8c.png";